import { render, staticRenderFns } from "./WrittenSupervision.vue?vue&type=template&id=0bf833ad&scoped=true&"
import script from "./WrittenSupervision.vue?vue&type=script&lang=ts&"
export * from "./WrittenSupervision.vue?vue&type=script&lang=ts&"
import style0 from "./WrittenSupervision.vue?vue&type=style&index=0&id=0bf833ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf833ad",
  null
  
)

export default component.exports